import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setLateFee } from '../../redux/modules/titlefees';
import Dropdown from '../../components/Dropdown';
import precise from '../../modules/precise';
import getPipeValue from '../../modules/getPipeValue';

class LateFee extends Component {
  constructor(props) {
    super(props);
    this.onValueSelect = this.onValueSelect.bind(this);
  }

  onValueSelect(event) {
    const value = event.target.value;
    const label = this.getOptions()[event.target.selectedIndex][0];
    this.props.setLateFee(precise(value), value, label);
  }

  // function LoadTitle20late() {
  //   //set the Title Late Penalty for Vessels and OH to $10
  //   var ltl = thisGetField("10LateFee")
  //   ltl.prop('readonly', false);
  //   ltl.clearItems();
  //   ltl.setItems([
  //       ["No Title Late Fee (within 30 days)", 0.00],
  //       ["Add Title Late Fee $20 (over 30 days)", 20.00]
  //   ]);
  // }

  // function LoadTitle20late() {
  //   //set the Title Late Penalty for Vessels and OH to $10
  //   var ltl = thisGetField("10LateFee")
  //   ltl.prop('readonly', false);
  //   ltl.clearItems();
  //   ltl.setItems([
  //       ["No Title Late Fee (within 30 days)", 0.00],
  //       ["Add Title Late Fee $20 (over 30 days)", 20.00]
  //   ]);
  // }

  // function LoadVesselTitle10late() {
  //   //set the Title Late Penalty for Vessels and OH to $10
  //   var lvtl = thisGetField("10LateFee");
  //   lvtl.prop('readonly', false);;
  //   lvtl.clearItems();
  //   lvtl.setItems([
  //       ["No Title Late Fee (within 30 days)", 0.00],
  //       ["Add Title Late Fee $10 (over 30 days)", 10.00]
  //   ]);
  // }

  getOptions() {
    const { selectedVehicleValue } = this.props;
    const { floridaTitle, mcoTitle, osTitle } = this.props.selectedTitleVariables;
    const t2 = Number(this.props.selectedTitleVariables.t2);

    let r16 = 0;
    if (selectedVehicleValue) {
      r16 = Number(getPipeValue(selectedVehicleValue, 'r16'));
    }

    // Just for debugging. Remove after fully tested.
    // console.log('LateFee, getOptions', { r16, t2, floridaTitle, mcoTitle, osTitle });

    const loadTitle20late = [
      ['No Title Late Fee (within 30 days)', 0],
      ['Add Title Late Fee $20 (over 30 days)', 20],
    ];

    const loadVesselTitle10late = [
      ['No Title Late Fee (within 30 days)', 0.00],
      ['Add Title Late Fee $10 (over 30 days)', 10.00],
    ];

    let dropdown = loadTitle20late;

    // Note: we have to sortof 'cascade' down the list of
    // dropdowns because of how John formatted his PDF Code.

    // These are the options are they appear in the PDF
    // when you choose an option from `Florida Title`
    if (floridaTitle) {
      if (r16 === t2 || r16 === 0 || t2 === 8) {
        if (t2 === 4) {
          dropdown = loadTitle20late;
        }

        if (t2 !== 5 || t2 !== 7) {
          dropdown = loadTitle20late;
        }

        if (t2 === 5) {
          dropdown = loadVesselTitle10late;
        }

        if (t2 === 7) {
          dropdown = loadVesselTitle10late;
        }
      }
    }

    // These are the options are they appear in the PDF
    // when you choose an option from `MCO Manufacturer`
    if (mcoTitle) {
      if (r16 === t2 || r16 === 0) {
        if (t2 !== 5 || t2 !== 7) {
          dropdown = loadTitle20late;
        }

        if (t2 === 5) {
          dropdown = loadVesselTitle10late;
        }

        if (t2 === 7) {
          dropdown = loadVesselTitle10late;
        }
      }
    }

    // These are the options are they appear in the PDF
    // when you choose an option from `Out of State Title`
    if (osTitle) {
      if (r16 === t2 || r16 === 0) {
        if (t2 !== 5 || t2 !== 7) {
          dropdown = loadTitle20late;
        }

        if (t2 === 5) {
          dropdown = loadVesselTitle10late;
        }

        if (t2 === 7) {
          dropdown = loadVesselTitle10late;
        }
      }
    }

    return dropdown;
  }

  render() {
    const { lateFeeSelectedValue, lateFee, lateFeeSelectedValueLabel } = this.props;
    return (
      <div className="Row Title-feeRow">

        <input
          id="Tsub4"
          data-id="Late Fee Total"
          data-tooltip="Plus $ Title Lien Fees"
          type="text"
          value={lateFee}
          readOnly
          className="Row-total"
          tabIndex="-1"
        />

        <Dropdown
          id="10LateFee"
          data-tooltip="Title Late Fee - Penalty"
          options={this.getOptions()}
          onChange={this.onValueSelect}
          selectedValue={lateFeeSelectedValue}
          className="Dropdown Row-dropdown no-print"
        />

        <b className="print-label print-only">{lateFeeSelectedValueLabel}</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedVehicleValue: state.registration.selectedVehicleValue,
    selectedTitleVariables: state.titlefees.selectedTitleVariables,
    lateFee: state.titlefees.lateFee,
    lateFeeSelectedValue: state.titlefees.lateFeeSelectedValue,
    lateFeeSelectedValueLabel: state.titlefees.lateFeeSelectedValueLabel,
  };
};

export default connect(mapStateToProps, { setLateFee })(LateFee);



// WEBPACK FOOTER //
// ./src/containers/titlefees/LateFee.js